import Backbone from 'backbone';

export const ResetEnvironmentModel = Backbone.Model.extend({

  initialize: function() {
    this.channel = Backbone.Radio.channel( 'AppChannel' );
    this.app = this.channel.request( 'app' );
  },
});